export default {
  "content": "<path fill=\"#BBB\" fill-rule=\"evenodd\" d=\"M.868.157c.751-.391 1.643-.026 1.993.815l5 12.046c.182.44.186.947.01 1.39l-5 12.594c-.337.848-1.223 1.23-1.98.853-.757-.377-1.098-1.37-.761-2.218l4.723-11.895L.14 2.389C-.21 1.547.117.549.868.157z\" clip-rule=\"evenodd\"/>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "width": "8",
    "height": "28",
    "fill": "none",
    "viewBox": "0 0 8 28"
  }
};